import { useState } from 'react';

const DEFAULT_NAME = 'U. N. Mehta Institute of Cardiology & Research Centre';
const DEFAULT_SUB = 'Affiliated to B. J. Medical College, Ahmedabad-380016, INDIA';

/**
 * Printed-document header: the institute seal + name.
 * The seal image is Settings → letterheadUrl if set, otherwise the bundled
 * /logo.png; if both fail to load the name text still shows on its own.
 */
export default function Letterhead({ org }: { org?: { name?: string; subtitle?: string; letterheadUrl?: string } }) {
  const configured = org?.letterheadUrl?.trim();
  const [src, setSrc] = useState<string | null>(configured || '/logo.png');
  const name = org?.name || DEFAULT_NAME;
  const sub = org?.subtitle || DEFAULT_SUB;

  function onImgError() {
    if (src && src !== '/logo.png') setSrc('/logo.png'); // configured URL failed → bundled
    else setSrc(null);                                    // bundled failed too → text only
  }

  return (
    <div className="letterhead">
      {src && <img className="lh-logo" src={src} alt="" onError={onImgError} />}
      <div className="lh-text">
        <div className="lh-name">{name}</div>
        <div className="lh-sub">({sub})</div>
      </div>
    </div>
  );
}
